<template>
	<div class="section-infopartners">
		<p class="text-h4 mb-6 font-weight-bold text-center primary--text">Мы благодарим наших партнеров</p>
		<v-row
			class="section-infopartners__logos align-center mx-auto"
			:class="[$vuetify.breakpoint.xs ? 'justify-center' : ' justify-space-between ']"
		>
			<v-col v-for="(Item, index) in ItemsRowOne" :key="index">
				<a :href="Item.url">
					<v-img :src="Item.image" contain :width="Item.width" height="70" class="mx-auto" />
				</a>
			</v-col>
			<v-col class="section-infopartners__logo" v-for="(Item, index) in ItemsRowTwo" :key="index">
				<a :href="Item.url">
					<v-img :src="Item.image" contain :width="Item.width" height="70" class="mx-auto" />
				</a>
			</v-col>
		</v-row>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionPartners',
	data: () => ({
		ItemsRowOne: [
			{
				image: require('@/assets/images/partners/2023/PSB.svg'),
				url: 'https://www.psbank.ru/',
				width: 204,
			},
			{
				image: require('@/assets/images/partners/2023/rosgosstrah.svg'),
				url: 'https://gum-katok.pulse.insure',
				width: 287,
			},
			{
				image: require('@/assets/images/partners/2023/exeed.svg'),
				url: 'https://exeed.ru/',
				width: 200,
			},
			{
				image: require('@/assets/images/partners/2023/lottery.svg'),
				url: 'https://nloto.ru/',
				width: 187,
			},
		] as Array<partnerLink>,
		ItemsRowTwo: [
			{
				image: require('@/assets/images/partners/2023/coolcola.svg'),
				url: 'https://ochakovo.ru/brand/coolcola/',
				width: 150,
			},
			{
				image: require('@/assets/images/partners/2023/petelinka.svg'),
				url: 'https://petelinka.ru/',
				width: 110,
			},
			{
				image: require('@/assets/images/partners/2023/tele2.svg'),
				url: 'https://msk.tele2.ru/',
				width: 110,
			},
			{
				image: require('@/assets/images/partners/2023/Yappy.svg'),
				url: 'https://yappy.media/',
				width: 110,
			},
			{
				image: require('@/assets/images/partners/2023/BOSCO.svg'),
				url: 'https://boscobrand.ru/',
				width: 245,
			},
		] as Array<partnerLink>,
	}),
});

class partnerLink {
	image!: string;
	url!: string;
	width!: number;
}
</script>

<style lang="scss">
.section-infopartners__logos {
	max-width: 1145px;

	.section-infopartners__logo {
		width: 100%;
		@media (min-width: 442px) {
			&:last-of-type {
				margin-bottom: 2rem;
			}
		}
	}
}
</style>
